// Correctly format the currency for each language
export const formatCurrency = (amount, language) => {
	return new Intl.NumberFormat(language === "fr" ? "fr-FR" : "en-GB", {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: 2,
	}).format(amount);
};
